/**
 * Where the RAM list in `state.users.ramUsers` is read from. Decided once per
 * session by `ensureManagerListSources` and kept in
 * `state.users.managerListSources`.
 *
 * @enum {string}
 */
export const RamUsersSource = {
  SalesMetros: 'salesMetros',
  Monolith: 'monolith',
};

/**
 * Where the DSO manager list in `state.users.dsoManagers` is read from.
 *
 * @enum {string}
 */
export const DsoManagersSource = {
  AuthService: 'authService',
  Monolith: 'monolith',
};
